import { useState } from "react";
import useAxiosClient from "../../../../hooks/useAxiosClient";
import { useDispatch, useSelector } from "react-redux";
import { TRootState } from "../../../../store";
import { toast } from "react-toastify";
import { setBenPayoutOtp, setRefId } from "../bloc/beneficiariesSlice";

const useBenficiaryOtpVerification = ({ type }: { type?: string }) => {
  const { handlePostCall, handlePutCall } = useAxiosClient();

  const { adminId, selectedBeneficiary, benPayoutOtp, refId, payout, payoutClick } = useSelector(
    (state: TRootState) => ({
      adminId: state.auth.adminId,
      selectedBeneficiary: state.beneficiary.selectedBeneficiary,
      benPayoutOtp: state.beneficiary.benPayoutOtp,
      refId: state.beneficiary.refId,
      payout: state.payout.payout,
      payoutClick: state.beneficiary.payoutClick
    })
  );
  const dispatch = useDispatch();

  const [otpVal, setOtpVal] = useState("");
  const [otpScreen, setOtpScress] = useState(false);
  const [loading, setLoading] = useState(false);

  const sendOtpApiCall = (actType: string) => {
    let apiParams = {
      id: benPayoutOtp ? benPayoutOtp : 0,
      adminId: adminId,
      type: actType,
      reqId: payoutClick ? selectedBeneficiary?.id : 999,
    };

    handlePostCall({
      URL: "admin/trade-platform/trades/payments/otp",
      apiParams: apiParams,
    })
      .then(({ data, status }) => {
        toast.success(status.description);
        let d = data as any;
        if (data) {
          // setOtpId(d?.id);
          dispatch(setBenPayoutOtp(d?.id));
          setOtpScress(true);
        }
      })
      .catch((err: any) => {
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onVerifyOtp = () => {
    if (otpVal == "") {
      toast.error("Please enter OTP");
      return;
    }
    if (otpVal.length !== 6) {
      toast.error("Please enter 6 digit OTP");
      return;
    }

    let apiParams: any = {
      id: benPayoutOtp,
      adminId: adminId,
      otp: otpVal,
    };

    if (payoutClick === true) {
      apiParams = {
        ...apiParams,
        pmtRefId: payout?.referenceId,
        amount: payout?.amountPaid,
        pmtType: payout?.pmtType,
        type: 'TP_PMT',
      };
    }
    handlePutCall({
      URL: "admin/trade-platform/trades/payments/validate",
      apiParams: apiParams,
    })
      .then(({ data, status }) => {
        let d = data as any;
        if (data) {
          dispatch(setRefId(d?.refId));
          toast.success(status.description);
        } else {
          toast.error(status.description);
        }
      })
      .catch((err: any) => {
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return {
    otpVal,
    setOtpVal,
    onVerifyOtp,
    sendOtpApiCall,
    otpScreen,
    refId,
    // otpId,
    benPayoutOtp,
  };
};
export default useBenficiaryOtpVerification;
